import { createFileRoute } from '@tanstack/react-router';
import { TreasuryPage } from '@/features/finance';

export const Route = createFileRoute('/_auth/o/$orgId/finance/treasury')({
  component: TreasuryRoute,
});

function TreasuryRoute() {
  const { orgId } = Route.useParams();
  return <TreasuryPage orgId={orgId} />;
}
